import { nanoid } from 'nanoid'

interface Props {
  rows: number
  columns: number
}

const ShimmerRows = ({ rows, columns }: Props) => (
  <>
    {[...Array(rows)].map(() => (
      <tr key={`tr_${nanoid()}`}>
        {[...Array(columns)].map(() => (
          <td key={`td_${nanoid()}`} align="center" className="p-2">
            <div className="w-full rounded-md shimmer">&nbsp;</div>
          </td>
        ))}
      </tr>
    ))}
  </>
)

export default ShimmerRows
